import React from 'react';

import styled from 'styled-components';
import { FlexContainer, StyledButton } from 'styles/common';

import { CalendarIcon } from 'constants/icons';
import theme from 'constants/theme';

import { Typography12, Typography3 } from 'uiToolkit/Typography';

export const BottomBorderedButton = ({ dateType, active = false, dateText, onClick }) => (
  <Button disableRipple active={active} onClick={onClick}>
    <FlexContainer style={{ padding: '1rem 1rem 1rem 0' }}>
      <CalendarIcon color={active ? 'primary' : theme.palette.icons.black2} size="fixed14px" />
    </FlexContainer>
    <TextContainer>
      <Typography12 color={active ? 'primary' : theme.palette.text.dark1}>
        {dateType === 'start' ? 'Start' : 'End'}
      </Typography12>
      <Typography3 color={active ? 'primary' : theme.palette.text.heading}>{dateText}</Typography3>
    </TextContainer>
  </Button>
);
const TextContainer = styled(FlexContainer)`
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 0.75rem;
  margin-bottom: 0.75rem;
`;
const Button = styled(StyledButton)`
  border-bottom: 2px solid ${(props) => (props.active ? props.theme.palette.borders.blue : 'transparent')};
  border-radius: 0;
  padding: 0;
  margin: 0 1rem;
  &:hover {
    background: transparent;
  }
`;
